export default "__VITE_ASSET__D5a1ciBS__"